var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "card-content" },
      [
        _c("p", [
          _vm._v(
            "La carpeta ya contiene documentos con los siguientes nombres. ¿Qué acción desea realizar?"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column my-2" }, [
          _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
            _c("thead", [
              _c("th", [_vm._v("Nombre")]),
              _vm._v(" "),
              _c(
                "th",
                { attrs: { width: "45" } },
                [
                  _c(
                    "b-tooltip",
                    {
                      attrs: {
                        label: "Reemplazar documento existente",
                        position: "is-left",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-file" }),
                      _vm._v(" "),
                      _c("i", { staticClass: "fas fa-sync-alt" }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "th",
                { attrs: { width: "50" } },
                [_c("b-checkbox", { on: { input: _vm.selectAll } })],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.files, function (file, i) {
                return _c("tr", { key: `file-${i}` }, [
                  _c("td", [_c("p", [_vm._v(_vm._s(file))])]),
                  _vm._v(" "),
                  _c("td", { attrs: { width: "45" } }),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { width: "50" } },
                    [
                      _c("b-checkbox", {
                        attrs: { "native-value": file },
                        model: {
                          value: _vm.toReplace,
                          callback: function ($$v) {
                            _vm.toReplace = $$v
                          },
                          expression: "toReplace",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "b-notification",
          { attrs: { type: "is-warning is-light", closable: false } },
          [
            _c("i", { staticClass: "fas fa-exclamation-triangle mr-2" }),
            _vm._v(
              "\n      Al reemplazar un documento, este se borrará definitivamente.\n    "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: { click: _vm.cancel },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "card-footer-item has-text-weight-bold is-uppercase",
          class: { disabled: _vm.toReplace.length < 1 },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n      Reemplazar\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Subiendo documentos"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }